export default __webpack_public_path__ + "static/CircularStd-MediumItalic-450e39dc0d89e2be2f9bf7044347859d.ttf";